import { render, staticRenderFns } from "./IconWithBadge.vue?vue&type=template&id=0fbba4f0&scoped=true&"
import script from "./IconWithBadge.vue?vue&type=script&lang=js&"
export * from "./IconWithBadge.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/sass/style_custom.scss?vue&type=style&index=0&id=0fbba4f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbba4f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fbba4f0')) {
      api.createRecord('0fbba4f0', component.options)
    } else {
      api.reload('0fbba4f0', component.options)
    }
    module.hot.accept("./IconWithBadge.vue?vue&type=template&id=0fbba4f0&scoped=true&", function () {
      api.rerender('0fbba4f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/IconWithBadge.vue"
export default component.exports